// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2xtm6","detailsBorder":"styles_detailsBorder__hGF2d"};